import React, { FC } from 'react';
import { Spin } from 'antd';
import './SpinnerWrapper.module.css';

interface ISpinnerWrapperProps {
    size?: 'small' | 'default' | 'large';
    spinning?: boolean;
}

export const SpinnerWrapper: FC<ISpinnerWrapperProps> = React.memo(
    ({ size = 'default', spinning = true }) => {
        return <Spin size={size} spinning={spinning} />;
    }
);
